import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { skeletonLoading } from './utils'

interface PickUpStoreLabelProps {
  hasPickUp: boolean
  loading: boolean
}

const ICON_SIZE = 16

const loadPickupStockLabel = (hasPickUp: boolean) => {
  return {
    color: hasPickUp ? 'c-on-base' : 'c-muted-2 strike',
    testid: hasPickUp
      ? 'available-pick-up-stock-label'
      : 'unavailable-pick-up-stock-label',
    id: hasPickUp
      ? 'product.stock.pickUp.available'
      : 'product.stock.pickUp.unavailable',
  }
}

const PickUpStoreLabel: FC<PickUpStoreLabelProps> = ({
  hasPickUp,
  loading,
}) => {
  const { color, testid, id } = loadPickupStockLabel(hasPickUp)

  if (loading) {
    return skeletonLoading
  }

  return (
    <span className={`lh-copy truncate ${color}`} data-testid={testid}>
      <span className="mr2 ph2 items-center">
        <Icon type="nc-store" color="currentColor" size={ICON_SIZE} />
      </span>
      <span className="t-small" data-testid="stockPickUpInfo">
        <FormattedMessage id={id} />
      </span>
    </span>
  )
}

export default PickUpStoreLabel
